/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import CarouselArrowNavigator from '../../../Generics/CarouselArrowNavigator'

const ProductsArrowNavigator = ({ swiper, productsTotal, similarProductId }) => {
  const [isNextAvailable, setIsNextAvailable] = useState(false)
  const [isPrevAvailable, setIsPrevAvailable] = useState(false)

  const onSlideChange = ({ isBeginning, isEnd }) => {
    setIsNextAvailable(!isEnd)
    setIsPrevAvailable(!isBeginning)
  }

  useEffect(() => {
    if (swiper) {
      swiper.on('slideChange', onSlideChange)
    }
  }, [swiper])

  useEffect(() => {
    const enableNextButton = swiper?.params?.slidesPerView < productsTotal
    const enablePrevButton = swiper?.activeIndex > 0
    setIsPrevAvailable(enablePrevButton)
    setIsNextAvailable(enableNextButton)
  }, [swiper, similarProductId])

  return (
    <CarouselArrowNavigator
      isNextAvailable={isNextAvailable}
      isPrevAvailable={isPrevAvailable}
      swiper={swiper}
    />
  )
}

ProductsArrowNavigator.propTypes = {
  swiper: PropTypes.shape({
    slideNext: PropTypes.func.isRequired,
    slidePrev: PropTypes.func.isRequired,
  }),
  productsTotal: PropTypes.number.isRequired,
  similarProductId: PropTypes.string.isRequired,
}

ProductsArrowNavigator.defaultProps = {
  swiper: null,
}

ProductsArrowNavigator.displayName = 'ProductsArrowNavigator'
ProductsArrowNavigator.whyDidYouRender = true

export default ProductsArrowNavigator
